// export default Clients;

import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import { API_URL } from "../../utils/constant";
import makeAnimated from 'react-select/animated';
import * as XLSX from "xlsx";
import {
  deleteCustomerforest,
  fetchCustomersforestView,
  refreshCustomer,
  createCustomerforestView,
  updateCustomerforest,
  fetchThreatAnalyst,
  uploadexcelforest,
  forestGraphAttack,
  forestGraphBrandSecurity,
  forestGraphDataexposure,
  fetchCustomersforestViewSearch,
  forestGraphDashboard,
  forestVendorDashboard,
  forestAvgScoreDashboard,
  forestRatingDecline,
  forestLowestRating,
  fetchCustomersById,
  forestCompanyList,
  forestSubdomainList,
  forestlistSearchRisk
} from "../../actions/customer";
import { IMAGE_URL } from "../../utils/constant";
import { Link, useLocation } from "react-router-dom";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import LineBarChart from "../common/apexChart/linebarChart";
import LineBarChartBrandSecurity from "../common/apexChart/linebarbrandsecurityChart";
import LineBarCharDataExposure from "../common/apexChart/linebardataexposureChart";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import ForestChart from "../common/forestChart";
import { GET_FOREST_LIST } from "../../actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Select from 'react-select';
import downloadIcon from '../../assets/images/downlaod3.svg';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


var ModelDashboard = require("../Dashboard/model");

const animatedComponents = makeAnimated();

const Clients = () => {
  const id = useSelector((state) => state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.auth?.user);
  const [orgId, setOrgId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isModal, setModal] = useState("");
  const [refreshModal, setRefreshModal] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState("");
  const [services, setServices] = useState([]);
  var date = new Date();
  date = moment(date).add(1, "year").toDate();
  const [expiredAt, selectDate] = useState(date);
  const [status, setStatus] = useState("all");
  const [firstLoad, setFirstLoad] = useState(true);
  const [PageSize, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalItemsSearch, setTotalItemsSearch] = useState(0);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [scanType, setscanType] = useState("No");
  const [scanScheduleDay, setscanScheduleDay] = useState("Sunday");
  const [orgName, setOrgName] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgContactName, setOrgContactName] = useState("");
  const [orgContact, setOrgContact] = useState("");
  const [website, setWebsite] = useState("");
  const [emailAccess, setEmailAccess] = useState(false);
  const [clientType, setClientType] = useState("1");
  const [plan, setPlan] = useState("basic");
  const [industryType, setindustryType] = useState("Government");
  const [domains, setDomain] = useState([]);
  const [authMethod, setAuthMethod] = useState("default");
  const [serverType, setServerType] = useState("");
  const [loginUrl, setLoginUrl] = useState("");
  const [logo, setLogo] = useState("");
  const [subscriptionType, setSubscriptionType] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [loginPage, setLoginPage] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [forestRiskData, setForestRisk] = useState([]);
  const [forestRiskIndData, setForestIndRisk] = useState([]);

  const [facebookUrl, setFacebookUrl] = useState("");
  const [twitterUrl, setTwitterUrl] = useState("");
  const [linkedinUrl, setLinkedinUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [page, setPage] = useState(1);
  const [cvetech, setCveTech] = useState('cve');
  const [seachCveTech, setSeachCveTech] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);


  const [keyWord, setKeyword] = useState("");
  const [license, setLicense] = useState("");
  const [criticality, setCriticality] = useState("Medium");
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const isMSSP = JSON.parse(localStorage.getItem("user")).accessLevel === "MSSP";
  const [activeTab, setActiveTab] = useState('tab1');
  const [tableFilter, setTableFilter] = useState("searchCve");
  const [organisations, setOrganisationsId] = useState("");
  const [submodules, setSubmodules] = useState("");
  const [riskValue, setRiskValue] = useState("");
  const [searchCompany, setSearchCompany] = useState("");
  const [moduleKey, setModuleKey] = useState('');
  const [optionValue, setOptionValue] = useState('');
  const [optionValueSubModule, setOptionValueSubModule] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const dropdownRefs = useRef({});
  // Add new state for tech modal
  const [techModalOpen, setTechModalOpen] = useState(false);
  const [selectedTechData, setSelectedTechData] = useState([]);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [cveModalOpen, setCveModalOpen] = useState(false);
  const [cveData, setCveData] = useState(null);
  const [criticalityFilter, setCriticalityFilter] = useState("");
  const [tagsFilter, setTagsFilter] = useState("");
  const [tagOptions, setTagOptions] = useState([]);
  const [isLoadingTags, setIsLoadingTags] = useState(false);
  const [showTechstackModal, setShowTechstackModal] = useState(false);
  const [selectedTechstacks, setSelectedTechstacks] = useState([]);

  // Add this useEffect to load tags when component mounts
  useEffect(() => {
    if (id) {
      setIsLoadingTags(true);
      axios.get(`https://api.brandsek.com/api/organisation/${id}/sub-org-tags`)
        .then(response => {
          const tags = response.data.data.uniqueTags;
          setTagOptions(tags.map(tag => ({ value: tag, label: tag })));
        })
        .finally(() => {
          setIsLoadingTags(false);
        });
    }
  }, [id]);

  const loadTagOptions = (inputValue) => {
    setIsLoadingTags(true);
    return axios.get(`https://api.brandsek.com/api/organisation/${id}/sub-org-tags`)
      .then(response => {
        const tags = response.data.data.uniqueTags;
        return tags
          .filter(tag => tag.toLowerCase().includes(inputValue.toLowerCase()))
          .map(tag => ({ value: tag, label: tag }));
      })
      .finally(() => {
        setIsLoadingTags(false);
      });
  };

  // Function to handle dropdown toggle
  const toggleDropdown = (id) => {
    if (dropdownOpen === id) {
      setDropdownOpen(null);
    } else {
      setDropdownOpen(id);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownOpen !== null) {
        const dropdownElement = dropdownRefs.current[dropdownOpen];
        if (dropdownElement && !dropdownElement.contains(event.target)) {
          setDropdownOpen(null);
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const history = useHistory();
  const location = useLocation(); // This hook gives access to the current location

  // Mapping of paths to tab IDs
  const pathToTabMapping = {
    '/vendor/home': 'tab1',
    '/vendor/companies': 'tab2',
    '/vendor/search': 'tab4',
    '/vendor/risks': 'tab5'
  };

  // Set active tab based on current path when component mounts or URL changes
  useEffect(() => {
    const path = location.pathname;
    if (pathToTabMapping[path]) {
      handleTabClick(pathToTabMapping[path]);

      // If it's the risks tab, also call these functions
      if (pathToTabMapping[path] === 'tab5') {
        forestSubdomainList(dispatch);
        setOptionValue();
        setOptionValueSubModule();
      }
    }
  }, [location.pathname]); // Re-run this effect when the path changes

  const handleRowClick = (item) => {
    setSelectedTechstacks(item.techstacks || []);
    setShowTechstackModal(true);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const findingClick = (item) => {
    // If a single organization is selected, redirect directly to findings page
    if (organisations && !organisations.includes(',')) {
      // Get the module formatted risk value
      const formattedRisk = formatString(item.module);

      // Redirect directly based on the risk type
      if (formattedRisk === 'High Risk Vulnerability') {
        history.push(`/known-vulnerabilities/vendor/${organisations}`);
      } else if (formattedRisk === 'Exploitable Obsolete Technology') {
        history.push(`/web-technology/vendor/${organisations}`);
      } else if (formattedRisk === 'Dangling Subdomain') {
        history.push(`/subdomains/vendor/${organisations}`);
      } else if (formattedRisk === 'Expired Ssl Certificate') {
        history.push(`/vulnerable-certificates/vendor/${organisations}`);
      } else if (formattedRisk === 'Vulnerable Obsolete Technology') {
        history.push(`/web-technology/vendor/${organisations}`);
      } else if (formattedRisk === 'Stolen Cred') {
        history.push(`/stolen-credentials/vendor/${organisations}`);
      } else if (formattedRisk === 'Malware Cred') {
        history.push(`/malware-credentials/vendor/${organisations}`);
      } else if (formattedRisk === 'Leaked Session') {
        history.push(`/leaked-sessions/vendor/${organisations}`);
      } else if (formattedRisk === 'Personal Information Breach') {
        history.push(`/pii/vendor/${organisations}`);
      } else if (formattedRisk === 'Lookalike Domain') {
        history.push(`/look-alike/vendor/${organisations}`);
      } else if (formattedRisk === 'Fake Social Media Profile') {
        history.push(`/social-media/vendor/${organisations}`);
      } else if (formattedRisk === 'leaked-code') {
        history.push(`/source-code/vendor/${organisations}`);
      } else if (formattedRisk === 'Vulnerable Ssl Certificate') {
        history.push(`/vulnerable-certificates/vendor/${organisations}`);
      } else if (formattedRisk === 'Postman') {
        history.push(`/postman-monitoring/vendor/${organisations}`);
      } else {
        // Default case - still fetch the company list and go to tab6 if no direct route matches
        forestCompanyList(id, item.module, dispatch, organisations)
        setRiskValue(formatString(item.module))
        handleTabClick('tab6')
      }
    } else {
      // Normal flow - fetch company list and show tab6
      forestCompanyList(id, item.module, dispatch, organisations)
      setRiskValue(formatString(item.module))
      handleTabClick('tab6')
    }
  }

  const routeCheck = (v) => {
    // sessionStorage.setItem('vendorName', capitalizeFirstLetter(v.orgName));
    // sessionStorage.setItem('vendorId', v?._id)

    // If organizations filter is set to a single company, skip the view details step
    if (organisations && !organisations.includes(',')) {
      // Direct redirect based on risk type
      if (riskValue == 'High Risk Vulnerability') {
        history.push(`/known-vulnerabilities/vendor/${organisations}`);
      } else if (riskValue == 'Exploitable Obsolete Technology') {
        history.push(`/web-technology/vendor/${organisations}`);
      } else if (riskValue == 'Dangling Subdomain') {
        history.push(`/subdomains/vendor/${organisations}`);
      } else if (riskValue == 'Expired Ssl Certificate') {
        history.push(`/vulnerable-certificates/vendor/${organisations}`);
      } else if (riskValue == 'Vulnerable Obsolete Technology') {
        history.push(`/web-technology/vendor/${organisations}`);
      } else if (riskValue == 'Stolen Cred') {
        history.push(`/stolen-credentials/vendor/${organisations}`);
      } else if (riskValue == 'Malware Cred') {
        history.push(`/malware-credentials/vendor/${organisations}`);
      } else if (riskValue == 'Leaked Session') {
        history.push(`/leaked-sessions/vendor/${organisations}`);
      } else if (riskValue == 'Personal Information Breach') {
        history.push(`/pii/vendor/${organisations}`);
      } else if (riskValue == 'Lookalike Domain') {
        history.push(`/look-alike/vendor/${organisations}`);
      } else if (riskValue == 'Fake Social Media Profile') {
        history.push(`/social-media/vendor/${organisations}`);
      } else if (riskValue == 'leaked-code') {
        history.push(`/source-code/vendor/${organisations}`);
      } else if (riskValue == 'Vulnerable Ssl Certificate') {
        history.push(`/vulnerable-certificates/vendor/${organisations}`);
      } else if (riskValue == 'Postman') {
        history.push(`/postman-monitoring/vendor/${organisations}`);
      }
    } else {
      // Normal flow when multiple or no companies are selected
      if (riskValue == 'High Risk Vulnerability') {
        history.push(`/known-vulnerabilities/vendor/${v?._id}`);
      } else if (riskValue == 'Exploitable Obsolete Technology') {
        history.push(`/web-technology/vendor/${v?._id}`);
      } else if (riskValue == 'Dangling Subdomain') {
        history.push(`/subdomains/vendor/${v?._id}`);
      } else if (riskValue == 'Expired Ssl Certificate') {
        history.push(`/vulnerable-certificates/vendor/${v?._id}`);
      } else if (riskValue == 'Vulnerable Obsolete Technology') {
        history.push(`/web-technology/vendor/${v?._id}`);
      } else if (riskValue == 'Stolen Cred') {
        history.push(`/stolen-credentials/vendor/${v?._id}`);
      } else if (riskValue == 'Malware Cred') {
        history.push(`/malware-credentials/vendor/${v?._id}`);
      } else if (riskValue == 'Leaked Session') {
        history.push(`/leaked-sessions/vendor/${v?._id}`);
      } else if (riskValue == 'Personal Information Breach') {
        history.push(`/pii/vendor/${v?._id}`);
      } else if (riskValue == 'Lookalike Domain') {
        history.push(`/look-alike/vendor/${v?._id}`);
      } else if (riskValue == 'Fake Social Media Profile') {
        history.push(`/social-media/vendor/${v?._id}`);
      } else if (riskValue == 'leaked-code') {
        history.push(`/source-code/vendor/${v?._id}`);
      } else if (riskValue == 'Vulnerable Ssl Certificate') {
        history.push(`/vulnerable-certificates/vendor/${v?._id}`);
      } else if (riskValue == 'Postman') {
        history.push(`/postman-monitoring/vendor/${v?._id}`);
      }
    }
  }

  let customers = useSelector(
    (state) => state?.customer?.forestlist?.data?.forestViewClients
  );

  let dataTable = useSelector(
    (state) => state?.customer?.companyList?.data
  );

  let customerById = useSelector(
    (state) => state?.customer?.fetechCustomerById?.data?.[0] || []
  );

  let forestViewList = useSelector(
    (state) => state?.customer?.forestViewList?.data?.forestViewClients
  );

  let totalDataForest = useSelector(
    (state) => state?.customer?.forestViewList?.data?.totalForestViewClients
  );

  let totalListData = useSelector(
    (state) => state?.customer?.forestlist?.data?.totalForestViewClients
  );

  let attacksurface = useSelector(
    (state) => state?.customer?.forestgraphattacksurface?.data
  );

  let brandsecurity = useSelector(
    (state) => state?.customer?.forestgraphbrandsecurity?.data
  );

  let dataexposure = useSelector(
    (state) => state?.customer?.forestgraphdataexposure?.data
  );

  let avgCount = useSelector(
    (state) => state?.customer?.forestAvgCount?.data
  );

  let forestDashboard = useSelector(
    (state) => state?.customer?.forestDashboard?.data
  );

  let forestVendor = useSelector(
    (state) => state?.customer?.forestVendorCount?.data
  );

  let forestRatingList = useSelector(
    (state) => state?.customer?.forestRatingList?.data
  );

  let forestLowestRatingList = useSelector(
    (state) => state?.customer?.forestLowestList?.data
  );


  let suggestModulesList = useSelector(
    (state) => state?.customer?.sudomainsuggest?.data
  );

  const riskSearchData = useSelector(
    (state) => state?.customer?.searchListRisk?.data?.forestViewClients
  );

  const selectOptions = riskSearchData?.map(item =>
  ({
    value: item?._id,
    label: item?.orgName
  })
  )
  const handleChangeSearch = (v) => {
    if (v) {
      setTimeout(() => {
        setSearchCompany(v)
      }, 1000);
    }
  }

  useEffect(() => {
    if (id) {
      fetchCustomersforestView(id, dispatch, page, search, sortField, sortOrder, '', '');
    }
  }, [id, page, search, sortField, sortOrder]);

  useEffect(() => {
    if (id) {
      forestlistSearchRisk(id, dispatch, searchCompany)
    }
  }, [id, searchCompany])


  useEffect(() => {
    if (id) {
      forestVendorDashboard(id, dispatch)
    }
  }, [id])

  useEffect(() => {
    if (id) {
      forestRatingDecline(id, dispatch, 1)
    }
  }, [id])

  useEffect(() => {
    if (id) {
      forestGraphDashboard(id, dispatch)
    }
  }, [id])

  useEffect(() => {
    if (id) {
      forestAvgScoreDashboard(id, dispatch)
    }
  }, [id, dispatch])

  useEffect(() => {
    if (id) {
      forestGraphAttack(id, dispatch)
    }
  }, [id])

  useEffect(() => {
    if (id) {
      forestGraphDataexposure(id, dispatch)
    }
  }, [id])

  useEffect(() => {
    if (id) {
      forestGraphBrandSecurity(id, dispatch)
    }
  }, [id])

  useEffect(() => {
    setTotalItems(totalListData)
  }, [totalListData])

  useEffect(() => {
    setTotalItemsSearch(totalDataForest)
  }, [totalDataForest])

  useEffect(() => {
    if (id) {
      forestLowestRating(id, dispatch, 1)
    }
  }, [id])


  let clientTypeData = [];
  if (JSON.parse(localStorage.getItem("user")).accessLevel === "MSSP")
    clientTypeData = [{ id: 1, text: "Client" }];
  else
    clientTypeData = [
      { id: 1, text: "Client" },
      { id: 3, text: "MSSP" },
    ];

  let subscriptionTypeData = [];
  let subscriptionValueMSSP = [
    { val: "", text: "MSSP Subscription Type" },
    { val: "trial", text: "Trial" },
    { val: "regular", text: "Regular Client" },
  ];
  let subscriptionValueClient = [
    { val: "", text: "Subscription Type" },
    { val: "platinum", text: "Platinum" },
  ];

  const formatString = (str) => {
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  if (JSON.parse(localStorage.getItem("user")).accessLevel === "MSSP") {
    if (
      JSON.parse(localStorage.getItem("user")).organisationId
        ?.subscriptionType == "trial"
    ) {
      subscriptionValueMSSP = [
        { val: "", text: "Subscription Type" },
        { val: "trial", text: "Trial" },
      ];
    } else {
      subscriptionValueMSSP = [
        { val: "", text: "Subscription Type" },
        // {val: "trial", text: "Trial" },
        // {val: "one-time", text: "One time" },
        // {val: "gold", text: "Gold" },
        { val: "platinum", text: "Platinum" },
      ];
    }
  }

  let mapData = customers;
  let currentTableData = [];
  currentTableData = mapData;


  let mapDataForest = forestViewList;
  let currentTableDataForest = [];
  currentTableDataForest = mapDataForest;

  const handleClick = (id) => {
    if (id == "keyword") {
      let val = $("#keyword").val();
      let _keyWord = keyWord || [];
      if (plan == "pro" && _keyWord.length >= 5) {
        toastr.error("Error", "Maximum keyword limit reached for this plan.");
        return false;
      }
      if (plan == "corporate" && _keyWord.length >= 50) {
        toastr.error("Error", "Maximum keyword limit reached for this plan.");
        return false;
      }
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#keyword").val("");
      // _keyWord.push(val);
      setKeyword([..._keyWord, val]);
    } else if (id == "facebook") {
      let val = $("#facebookUrl").val();
      let _keyWord = facebookUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#facebookUrl").val("");
      // _keyWord.push(val);
      setFacebookUrl([..._keyWord, val]);
    } else if (id == "linkedin") {
      let val = $("#liknedinUrl").val();
      let _keyWord = linkedinUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#liknedinUrl").val("");
      // _keyWord.push(val);
      setLinkedinUrl([..._keyWord, val]);
    } else if (id == "twitter") {
      let val = $("#twitterUrl").val();
      let _keyWord = twitterUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#twitterUrl").val("");
      // _keyWord.push(val);
      setTwitterUrl([..._keyWord, val]);
    } else if (id == "instagram") {
      let val = $("#instagramUrl").val();
      let _keyWord = instagramUrl || [];
      if (_keyWord.indexOf(val) != -1) {
        toastr.error("Error", "This keyword is already added.");
        return false;
      }
      $("#instagramUrl").val("");
      // _keyWord.push(val);
      setInstagramUrl([..._keyWord, val]);
    } else if (id == "tag") {
      let val = tagInput.trim();
      if (!val) return false;

      // Split the input by commas and spaces to handle multiple tags
      const newTags = val.split(/[,\s]+/).filter(tag => tag.trim() !== '');

      if (newTags.length === 0) return false;

      let _tags = [...(tags || [])];
      let addedCount = 0;

      // Process each tag
      newTags.forEach(tag => {
        const trimmedTag = tag.trim();
        if (trimmedTag && _tags.indexOf(trimmedTag) === -1) {
          _tags.push(trimmedTag);
          addedCount++;
        }
      });

      if (addedCount === 0) {
        toastr.error("Error", "All tags already exist");
        return false;
      }

      setTagInput("");
      setTags(_tags);
    } else {
      let val = $("#domain").val();
      let _domains = domains || [];
      if ((plan == "basic" || plan == "pro") && _domains.length >= 1) {
        toastr.error("Error", "Maximum domain limit reached for this plan.");
        return false;
      }
      if (plan == "corporate" && _domains.length >= 3) {
        toastr.error("Error", "Maximum domain limit reached for this plan.");
        return false;
      }
      if (_domains.indexOf(val) != -1) {
        toastr.error("Error", "This domain is already added.");
        return false;
      }
      var re = new RegExp(
        /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/
      );
      var valid = val.match(re);
      if (valid) {
        $("#domain").val("");
        // _domains.push(val);
        setDomain([..._domains, val]);
      } else {
        toastr.error("Error", "Please enter a valid domain.");
        return false;
      }
    }
  };

  const downloadFileExecutive = async (name, subOrgId) => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/pptxreport/organisation/${id}/subOrganisation/${subOrgId}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name?.replace(/\s+/g, '-')} Report.pptx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const SearchCve = (e) => {
    setSeachCveTech(e.target.value)
  };

  const searchClick = () => {
    fetchCustomersforestViewSearch(id, dispatch, tableFilter == 'searchCve' ? 'cve' : 'tech', seachCveTech || 'apache');
  }

  const removeKeyword = (_id, _keyword) => {
    if (_id == "keyword") {
      let newkeyword = keyWord;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setKeyword([...newkeyword]);
    } else if (_id == "facebook") {
      let newkeyword = facebookUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setFacebookUrl([...newkeyword]);
    } else if (_id == "linkedin") {
      let newkeyword = linkedinUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setLinkedinUrl([...newkeyword]);
    } else if (_id == "twitter") {
      let newkeyword = twitterUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setTwitterUrl([...newkeyword]);
    } else if (_id == "instagram") {
      let newkeyword = instagramUrl;
      newkeyword.splice(newkeyword.indexOf(_keyword), 1);
      setInstagramUrl([...newkeyword]);
    } else if (_id == "tag") {
      let newTags = [...tags];
      newTags.splice(newTags.indexOf(_keyword), 1);
      setTags(newTags);
    } else {
      let _domain = domains;
      _domain.splice(_domain.indexOf(_keyword), 1);
      setDomain([..._domain]);
    }
  };

  const removeLogo = () => {
    setLogo("");
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
    }
  };

  const createFormData = (data) => {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      const value = data[key];
      
      if (value instanceof File) {
        // Handle file objects
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        // Handle arrays
        formData.append(key, JSON.stringify(value));
      } else if (typeof value === 'object' && value !== null) {
        // Handle objects
        formData.append(key, JSON.stringify(value));
      } else if (value !== null && value !== undefined) {
        // Handle primitive values
        formData.append(key, value.toString());
      }
    });
    
    return formData;
  };

  const updateCustomerforestWithFormData = async (formData, id, updateId, dispatch) => {
    const session = localStorage.getItem("session");
    
    try {
      const response = await axios.put(`${API_URL}/organisations/${id}/fv-client/${updateId}`, formData, {
        headers: {
          'Authorization': `Bearer ${session}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
      }
      
      dispatch({
        type: "GET_FOREST_VIEW",
        payload: response.data,
      });
    } catch (err) {
      let message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: "GET_FOREST_VIEW",
        payload: { error: true, userMessage: message },
      });
    }
  };

  const createCustomerforestViewWithFormData = async (formData, id, auth, dispatch) => {
    const session = localStorage.getItem("session");
    
    try {
      const response = await axios.post(`${API_URL}/organisations/${id}/fv-client`, formData, {
        headers: {
          'Authorization': `Bearer ${session}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
      }
      
      dispatch({
        type: "GET_FOREST_VIEW",
        payload: response.data,
      });
    } catch (err) {
      let message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: "GET_FOREST_VIEW",
        payload: { error: true, userMessage: message },
      });
    }
  };

  const submitForm = () => {
    if (scanType !== "weekly") {
      setscanScheduleDay("");
    }

    if (orgName == "") {
      toastr.error("Error", "Please enter organisation name.");
      return false;
    }

    var regex =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    if (!regex.test(website)) {
      toastr.error("Error", "Website address is incorrect.");
      return false;
    }

    if (country == "") {
      toastr.error("Error", "Please select the country.");
      return false;
    }

    if (industryType == "") {
      toastr.error("Error", "Please select the industry type.");
      return false;
    }

    if (keyWord == "") {
      toastr.error("Error", "Please add keywords.");
      return false;
    }

    if (isEdit) {
      const updateData = {
        orgName,
        website,
        plan,
        domains,
        country,
        facebookUrl,
        twitterUrl,
        keyWord,
        expiredAt,
        industryType,
        criticality,
        tags,
        orgContactName,
        orgEmail,
        orgContact,
        address,
        state,
        city,
        logo,
      };
      
      const formData = createFormData(updateData);
      
      updateCustomerforestWithFormData(
        formData,
        id,
        updateId,
        dispatch
      );
    } else {
      const customerData = {
        orgName,
        website,
        plan,
        domains,
        country,
        facebookUrl,
        twitterUrl,
        keyWord,
        expiredAt,
        industryType,
        criticality,
        tags,
        orgContactName,
        orgEmail,
        orgContact,
        address,
        state,
        city,
        logo,
      };
      
      const formData = createFormData(customerData);
      
      createCustomerforestViewWithFormData(
        formData,
        id,
        auth,
        dispatch
      );
    }

    setModal("");
  };

  const addModal = () => {
    setIsEdit(false);
    setOrgName("");
    setOrgEmail("");
    setOrgContact("");
    setWebsite("");
    // setEmailAccess("")
    // setClientType("")
    // setSubscriptionType("")
    setDomain([]);
    setAuthMethod("");
    // setAssignTo("");
    setLogo("");
    // setSubscriptionType("")
    setAddress("");
    setCountry("");
    setState("");
    setCity("");
    setFacebookUrl("");
    setTwitterUrl("");
    setLinkedinUrl("");
    setInstagramUrl("");
    setKeyword("");
    setOrgContactName("");
    setscanScheduleDay("Sunday");
    // setServices(['AttackSurface','DarkWeb','BrandSecurity','TPSA'])
    setServices(["AttackSurface", "DarkWeb", "BrandSecurity"]);
    setscanType("No");
    setCriticality("Medium");
    setTags([]);
    setTagInput("");
    setModal("Form Wizard modal");
  };

  const editModal = (row) => {
    setUpdateId(row?._id);
    setIsEdit(true);
    setindustryType(row?.industryType);
    setOrgName(row?.orgName);
    setOrgEmail(row?.orgEmail);
    setOrgContact(row?.orgContact);
    setWebsite(row?.website);
    setLoginPage(row?.loginPage);
    setEmailAccess(row?.emailAccess);
    setClientType(row?.clientType);
    setSubscriptionType(row?.subscriptionType);
    setDomain(row?.domains);
    setAuthMethod(row?.authMethod);
    setLogo(row?.logo);
    setscanScheduleDay(row?.scanScheduleDay);
    setAddress(row?.address);
    setCountry(row?.country);
    setState(row?.state);
    setCity(row?.city);
    setscanType(row?.scanType);
    setFacebookUrl(row?.facebookUrl);
    setTwitterUrl(row?.twitterUrl);
    setLinkedinUrl(row?.linkedinUrl);
    setInstagramUrl(row?.instagramUrl);
    setKeyword(row?.keyWord);
    setOrgContactName(row?.orgContactName);
    selectDate(row?.expiredAt ? new Date(row?.expiredAt) : new Date());
    setServerType(row?.serverType);
    setLoginUrl(row?.loginUrl);
    setPlan(row?.plan || "basic");
    setCriticality(row?.criticality || "Medium");
    setTags(row?.tags || []);
    setModal("Form Wizard modal");
  };

  const deleteCustomerOption = (_id) => {
    const self = this;
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to delete this customer?",
      type: "red",
      buttons: {
        ok: {
          text: "Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            deleteCustomerforest(id, _id, dispatch);
          },
        },
        cancel: function () {
        },
      },
    });
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [blank, setblank] = useState(null);

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("excelFile", selectedFile);
      uploadexcelforest(formData, id, dispatch)
      setblank('');
    } else {
      toastr.error("Error", 'No file selected.');
    }
  };

  useEffect(() => {
    if (id) {
      axios.get(`https://api.brandsek.com/api/forest-view/organisations/${id}/risk-distribution`, {
        params: {
          modules: moduleKey,
          submodules: submodules,
          organisations: organisations,
          tags: tagsFilter,
          criticality: criticalityFilter
        }
      })
        .then(response => {
          setForestRisk(response.data);
        }).
        catch(error => {
        });
    }
  }, [id, moduleKey, submodules, organisations, tagsFilter, criticalityFilter]);

  const riskView = (module) => {
    if (id) {
      axios.get(`https://api.brandsek.com/api/forestView/organizations/${id}/stats/${module}/list/companies?organisations${organisations}`)
        .then(response => {
          setForestIndRisk(response.data);
          return response.data;
        }).
        catch(error => {
        });
    }
  }


  const options = suggestModulesList?.modules?.map((item) => ({
    value: item,
    label: item.charAt(0).toUpperCase() + item.slice(1).replace(/-/g, ' ')
  }));

  const optionsSubModule = suggestModulesList?.submodules?.map((item) => ({
    value: item,
    label: item.charAt(0).toUpperCase() + item.slice(1).replace(/-/g, ' ')
  }));


  const handleChange = (selected) => {
    const selectedValues = selected?.map(item => item.value);
    setOptionValue(selected);
    setModuleKey(selectedValues.join(', '));
  };

  const handleChangeSubModule = selected => {
    const selectedValues = selected?.map(item => item.value);
    setOptionValueSubModule(selected)
    setSubmodules(selectedValues.join(', '));
  };

  const handleSearch = selected => {
    const selectedValues = selected?.map(item => item.value.trim());
    setSearchValue(selected)
    setOrganisationsId(selectedValues.join(','));
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = () => {
    let data = {
      id: id
    };
    ModelDashboard.default.forsetReport(data).then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${clientName?.replace(/\s+/g, '-')}Reports-${id}.zip`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }).catch((error) => {
      // console.error removed
    });
  };

  const showCveDetails = (orgData) => {
    if (orgData) {
      // Ensure we're passing an array
      const dataArray = Array.isArray(orgData) ? orgData : [orgData];
      setCveData(dataArray);
      setCveModalOpen(true);
    }
  };

  return (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Dashboard</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                    {/* Forest View */}
                  </> : <Link to="/vendor" className="welcome-textSmall">Third Party Risk Management</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      {vendorName}
                    </li> : ''
                }

              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end align-items-center">
            {/* {mapData?.length === 0 ? null : ( */}
            <span>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  downloadFile();
                  // exportToCSV(downloadCsvData, "Sub-Domain Details");
                }}
                href="/add-report"
                className="btn btn-primary mr-1 download-report"
              >
                Download Details
              </a>
            </span>
            {/* )} */}
          </div>
        </div>
      </div>
      <div>
        <div className="tabs tabs_css">
          <button onClick={() => {
            handleTabClick('tab1');
            setOrganisationsId();
            history.push('/vendor/home');  // Use history.push instead of navigate
          }} className={activeTab === 'tab1' ? 'active' : ''}>
            Home
          </button>
          <button onClick={() => {
            handleTabClick('tab2');
            setOrganisationsId();
            history.push('/vendor/companies');  // Use history.push instead of navigate
          }} className={activeTab === 'tab2' ? 'active' : ''}>
            Vendors
          </button>
          <button onClick={() => {
            handleTabClick('tab4');
            setOrganisationsId();
            history.push('/vendor/search');  // Use history.push instead of navigate
          }} className={activeTab === 'tab4' ? 'active' : ''}>
            Search
          </button>
          {/* <button onClick={() => {
            handleTabClick('tab5');
            setOrganisationsId();
            forestSubdomainList(dispatch);
            setOptionValue();
            setOptionValueSubModule();
            history.push('/vendor/risks');  // Use history.push instead of navigate
          }} className={activeTab === 'tab5' ? 'active' : ''}>
            Risks
          </button> */}
        </div>
        <div className="tab-content">
          {activeTab === 'tab1' && <div>
            <div className="row clearfix">
              <div className="col-md-4">
                <div className="row clearfix">
                  <div className="col-md-12">
                    <div className="card w_card3 knowCard">
                      <div
                        className="body"
                      >
                        <div className="text-center">
                          <p>Vendor Rating (Average Rating)</p>
                          <h4 className="font-20 total-h4">
                            {avgCount?.averageScore?.toFixed(2) || 0} <span className="span_total">
                              / 800
                            </span>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="card w_card3 knowCard mb-0">
                      <div
                        className="body"
                      >
                        <div className="text-center">
                          <p>Total Vendors</p>
                          <h4 className="font-20 total-h4">
                            {forestVendor?.totalVendors?.toFixed(0) || 0}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-8">
                <div className="card">
                  <div className="body">
                    {forestDashboard ?
                      <ForestChart
                        data={forestDashboard}
                        name={"Average"}
                        color="#1DBF73"
                      /> : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-md-6">
                <div className="card">
                  <div className="body">
                    <p className="welcome-textSmall">
                      Lowest Rated
                    </p>
                    <div className="table-responsive">
                      <table className="table table-custom spacing5 mb-0">
                        <thead>
                          <tr>
                            <th>
                              Name
                            </th>
                            <th>
                              Security Rating
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {forestLowestRatingList?.forestViewClients?.slice(0, 4)?.map((res) => {
                            return (
                              <tr>
                                <td
                                >
                                  <a onClick={() => {
                                    // sessionStorage.setItem('vendorName', capitalizeFirstLetter(res.orgName));
                                    // sessionStorage.setItem('vendorId', res?._id)
                                  }}
                                    title=""
                                    style={{ color: "white", textDecoration: "underline" }}
                                    href={`/tprm/vendor/${res?._id}`} target="_blank">
                                    {res?.orgName || "N/A"}
                                  </a>
                                </td>
                                <td>
                                  {res?.totalImpact?.toFixed(2) || "N/A"}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <Link to="/forest-rating?tab=lowest"
                    >Show More</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div className="body">
                    <div className="d-flex justify-content-between align-item-center">
                      {/* <div> */}
                      <p className="welcome-textSmall">
                        Rating Decline
                      </p>
                      {/* <FontAwesomeIcon icon={faChartLineDown} />
                      </div> */}
                    </div>
                    <div className="table-responsive">
                      <table className="table table-custom spacing5 mb-0">
                        <thead>
                          <tr>
                            <th>
                              Name
                            </th>
                            <th>
                              Percentage Decrease
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {forestRatingList?.ratingDeltaInPercentageList?.slice(0, 4)?.map((res) => {
                            return (
                              <tr>
                                <td>

                                  <a onClick={() => {
                                    // sessionStorage.setItem('vendorName', capitalizeFirstLetter(res.orgName));
                                    // sessionStorage.setItem('vendorId', res?._id)
                                  }}
                                    title=""
                                    style={{ color: "white", textDecoration: "underline" }}
                                    href={`/tprm/vendor/${res?._id}`} target="_blank">
                                    {res?.orgName || "N/A"}
                                  </a>
                                </td>
                                <td>
                                  {res?.ratingDeltaInPercentage?.toFixed(2) + ' %' || "N/A"}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <Link to="/forest-rating?tab=decline"
                    >Show More</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>}
          {activeTab === 'tab2' && <div>
            <div className="row clearfix">
              <div className="col-md-4">
                <div className="card">
                  <div className="body" style={{ minHeight: "500px" }}>
                    <h6>Observations - ASM</h6>
                    <div id="University_Survey" className="flot-chart">
                      {/* <SurveyChart /> */}
                      {attacksurface && (
                        <LineBarChart
                          yAxis="Similar Domains found"
                          attacksurface={attacksurface}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <div className="body" style={{ minHeight: "500px" }}>
                    <h6>Observations - Data Exposure</h6>
                    <div id="University_Survey" className="flot-chart">
                      {/* <SurveyChart /> */}
                      {dataexposure && (
                        <LineBarCharDataExposure
                          yAxis="Similar Domains found"
                          dataexposure={dataexposure}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {window.location.pathname !== "/vendor/companies" && (
                <div className="col-md-4">
                  <div className="card">
                    <div className="body" style={{ minHeight: "500px" }}>
                      <h6>Observations - BrandSecurity</h6>
                      <div id="University_Survey" className="flot-chart">
                        {/* <SurveyChart /> */}
                        {brandsecurity && (
                          <LineBarChartBrandSecurity
                            yAxis="Similar Domains found"
                            brandsecurity={brandsecurity}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-lg-12 col-md-12">
                <div className="card">
                  <div className="body">
                    <div className="row justify-content-between">
                      <div className="col-lg-3 col-md-4 col-sm-12"></div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-custom spacing5 mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: "100px" }}>#</th>
                            <th>Vendor Name
                              <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortField('orgAlpha'); setSortOrder('asc') }}
                              />
                              <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                onClick={() => { setSortField('orgAlpha'); setSortOrder('desc') }}
                              />
                            </th>
                            <th>Attack surface Rating
                              <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortField('attackSurfaceSecurityImpact'); setSortOrder('asc') }}
                              />
                              <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                onClick={() => { setSortField('attackSurfaceSecurityImpact'); setSortOrder('desc') }}
                              />
                            </th>
                            <th>Data Exposure & Dark Web Rating
                              <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortField('darkWebSecurityImpact'); setSortOrder('asc') }}
                              />
                              <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                onClick={() => { setSortField('darkWebSecurityImpact'); setSortOrder('desc') }}
                              />
                            </th>
                            {window.location.pathname !== "/vendor/companies" && (
                              <th>Brand Security Rating
                                <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                  onClick={() => { setSortField('brandSecuritySecurityImpact'); setSortOrder('asc') }}
                                />
                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                  onClick={() => { setSortField('brandSecuritySecurityImpact'); setSortOrder('desc') }}
                                />
                              </th>
                            )}
                            <th>Overall Health Rating
                              <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortField('totalImpact'); setSortOrder('asc') }}
                              />
                              <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                onClick={() => { setSortField('totalImpact'); setSortOrder('desc') }}
                              />
                            </th>
                            <th>Industry Average</th>
                            <th>Created At</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentTableData?.map((item, index) => {
                            const pageCount = (page - 1) * 10 + 1;
                            return (
                              <tr>
                                <td style={{ width: "100px" }}>
                                  <span>{pageCount + index}</span>
                                </td>
                                <td>
                                  <a
                                    onClick={() => {
                                      // sessionStorage.setItem('vendorName', capitalizeFirstLetter(item.orgName));
                                      // sessionStorage.setItem('vendorId', item?._id)
                                    }}
                                    title=""
                                    style={{ color: "white", textDecoration: "underline" }}
                                    href={`/tprm/vendor/${item?._id}`} target="_blank">
                                    {capitalizeFirstLetter(item.orgName)}
                                  </a>
                                  <p className="mb-0">{item.orgContactName}</p>
                                </td>
                                <td>
                                  {item?.rating?.attackSurfaceSecurityImpact}
                                </td>
                                <td>
                                  {item?.rating?.darkWebSecurityImpact}
                                </td>
                                {window.location.pathname !== "/vendor/companies" && (
                                  <td>
                                    {item?.rating?.brandSecuritySecurityImpact}
                                  </td>
                                )}
                                <td>
                                  <span>
                                    {isNaN(
                                      window.location.pathname === "/vendor/companies"
                                        ? Number(item?.rating?.darkWebSecurityImpact) + Number(item?.rating?.attackSurfaceSecurityImpact)
                                        : Number(item?.rating?.darkWebSecurityImpact) + Number(item?.rating?.brandSecuritySecurityImpact) + Number(item?.rating?.attackSurfaceSecurityImpact)
                                    )
                                      ? ''
                                      : (window.location.pathname === "/vendor/companies"
                                        ? (Number(item?.rating?.darkWebSecurityImpact) + Number(item?.rating?.attackSurfaceSecurityImpact)).toFixed(2)
                                        : (Number(item?.rating?.darkWebSecurityImpact) + Number(item?.rating?.brandSecuritySecurityImpact) + Number(item?.rating?.attackSurfaceSecurityImpact)).toFixed(2)
                                      )
                                    }
                                  </span>
                                </td>
                                <td>
                                  {item?.industryAverage} ({item?.industryType})
                                </td>
                                <td>
                                  {item?.createdAt
                                    ? moment(item?.createdAt).format(
                                      "DD-MM-YYYY"
                                    )
                                    : "NA"}
                                </td>
                                <td className="text-center">
                                  {auth?.accessLevel != "Threat Analyst" && (
                                    <div className="dropdown dropdownLatestMulti" ref={el => dropdownRefs.current[item._id] = el}>
                                      <button type="button" className="btn p-0 dropdown-toggle-dots"
                                        onClick={() => toggleDropdown(item._id)}
                                      >
                                        <div className="dropDownDot">
                                          <div className="dropdown-dot"></div>
                                          <div className="dropdown-dot"></div>
                                          <div className="dropdown-dot"></div>
                                        </div>
                                      </button>
                                      <div className={`dropdown-menu ${dropdownOpen === item._id ? 'show' : ''}`}>
                                        <Link
                                          className="dropdown-item dropDownDotItems"
                                          to="#"
                                          onClick={() => {
                                            downloadFileExecutive(item.orgName, item._id);
                                          }}
                                        >
                                          <img src={downloadIcon} alt="download" style={{ marginRight: '12px', fontSize: '16px', width: '20px', color: '#6563ff' }} />
                                          Download Report
                                        </Link>
                                        {/* <Link
                                          className="dropdown-item dropDownDotItems"
                                          to="#"
                                          onClick={() => {
                                            // Set the company in search and redirect to risks tab
                                            setSearchCompany(item._id);
                                            setSearchValue([{ value: item._id, label: item.orgName }]);
                                            setOrganisationsId(item._id);
                                            handleTabClick('tab5');
                                            history.push('/vendor/risks');
                                          }}
                                        >


                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-exclamation-triangle dropdown-item-icon" viewBox="0 0 16 16">
                                            <path d="M8 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5zm0 8a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5z" />
                                            <path d="M8 12.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5zm0-8a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5z" />
                                          </svg>

                                          Risk View
                                        </Link> */}
                                      </div>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="dataTables_paginate">
                      {totalItems > 0 && (
                        <Pagination
                          className="pagination-bar"
                          currentPage={page}
                          totalCount={totalItems}
                          pageSize={PageSize}
                          onPageChange={(page) => setPage(page)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
                }`}
            >
              <div className="modal-dialog modal-lg clientPageModal" id="clientModal">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Vendor</h5>
                    <button
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => setModal("")}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body pricing_page">
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="card">
                        <div className="header">
                          <h2 className="welcome-textSmall font18px">Basic Information</h2>
                        </div>
                        <div className="row clearfix">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Client Name *"
                                value={orgName}
                                onChange={(e) => setOrgName(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text border-right-0">
                                    <i className="icon-globe"></i>
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  className="form-control border-left-0"
                                  placeholder="http://"
                                  value={website}
                                  onChange={(e) => setWebsite(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <select
                              className="form-control"
                              value={industryType}
                              onChange={(e) => {
                                setindustryType(e.target.value);
                              }}
                            >
                              <option value="Government">Government</option>
                              <option value="NGO">NGO</option>
                              <option value="Finance">Finance</option>
                              <option value="Technology">Technology</option>
                              <option value="Healthcare">Healthcare</option>
                              <option value="Education">Education</option>
                              <option value="Telecommunications">
                                Telecommunications
                              </option>
                              <option value="Manufacturing">Manufacturing</option>
                              <option value="Construction">Construction</option>
                              <option value="Energy">Energy</option>
                              <option value="Chemical">Chemical</option>
                              <option value="Media">Media</option>
                              <option value="Aerospace">Aerospace</option>
                              <option value="Transportation">Transportation</option>
                              <option value="Agriculture">Agriculture</option>
                              <option value="Retail">Retail</option>
                            </select>
                          </div>

                          <div className="col-lg-6 col-md-12">
                            <div className="form-group position-relative">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Domains"
                                name="domain"
                                id="domain"
                              />
                              <i
                                className="fa fa-plus iconPlusAbsoulte"
                                onClick={() => handleClick("domain")}
                                style={{ fontSize: "22px", color: "black" }}
                              ></i>
                            </div>
                          </div>

                          {domains && domains.length > 0 && (
                            <div className="col-lg-6 col-md-12">
                              <div className="row">
                                {domains?.map((keyword) => {
                                  return (
                                    <div className="col-md-4">
                                      <label
                                        className="labelClientAdd"
                                      >
                                        <span>
                                          {keyword}{" "}
                                          <span
                                            className="fa fa-times-circle"
                                            onClick={() =>
                                              removeKeyword("domain", keyword)
                                            }
                                          ></span>
                                        </span>
                                      </label>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}

                          <div className="col-lg-6 col-md-12">
                            <div className="form-group position-relative">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Key Words"
                                name="keyword"
                                id="keyword"
                              />
                              <i
                                className="fa fa-plus iconPlusAbsoulte"
                                onClick={() => handleClick("keyword")}
                                style={{ fontSize: "22px", color: "black" }}
                              ></i>
                            </div>
                          </div>

                          <div className="col-lg-6 col-md-12">
                            {keyWord && keyWord.length > 0 && (
                              <div className="row">
                                {keyWord.map((keyword) => {
                                  return (
                                    <div className="col-md-4">
                                      <label
                                        className="labelClientAdd"
                                      >
                                        <span>
                                          {keyword}{" "}
                                          <span
                                            className="fa fa-times-circle"
                                            onClick={() =>
                                              removeKeyword("keyword", keyword)
                                            }
                                          ></span>
                                        </span>
                                      </label>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          <div className="col-lg-6 col-md-12">
                            {logo && logo != "" && (
                              <div className="col-lg-6 col-md-12">
                                <div className="row">
                                  <img
                                    style={{ width: "100px" }}
                                    src={logo instanceof File ? URL.createObjectURL(logo) : `${IMAGE_URL}${logo}`}
                                  />
                                  <span
                                    className="fa fa-times-circle"
                                    style={{
                                      position: "absolute",
                                      marginTop: "-8px",
                                      marginLeft: "-8px",
                                      color: "red",
                                    }}
                                    onClick={() => removeLogo()}
                                  ></span>
                                </div>
                              </div>
                            )}
                          </div>

                          <hr />
                        </div>
                        <hr></hr>
                        <div>
                          <h6>Risk Assessment</h6>
                          <div className="row clearfix">
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label>Criticality</label>
                                <select
                                  className="form-control"
                                  value={criticality}
                                  onChange={(e) => setCriticality(e.target.value)}
                                >
                                  <option value="High">High</option>
                                  <option value="Medium">Medium</option>
                                  <option value="Low">Low</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-12">
                              <div className="form-group position-relative">
                                <label>Tags</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Tags"
                                  name="tagInput"
                                  id="tagInput"
                                  value={tagInput}
                                  onChange={(e) => setTagInput(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      e.preventDefault();
                                      handleClick("tag");
                                    }
                                  }}
                                />
                                <i
                                  className="fa fa-plus iconPlusAbsoulte iconPlusAbsoulte2"
                                  onClick={() => handleClick("tag")}
                                  style={{ fontSize: "22px", color: "black" }}
                                ></i>
                              </div>
                            </div>

                            {tags && tags.length > 0 && (
                              <div className="col-lg-12 col-md-12">
                                <div className="form-group mb-0">
                                  <div className="d-flex flex-wrap">
                                    {tags.map((tag, index) => (
                                      <div className="m-1" key={index}>
                                        <label className="labelClientAdd mb-2">
                                          <span>
                                            {tag}{" "}
                                            <span
                                              className="fa fa-times-circle"
                                              onClick={() => removeKeyword("tag", tag)}
                                            ></span>
                                          </span>
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <hr></hr>
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            style={{ color: "black", fontWeight: "bold" }}
                            className="btn btn-round btn-primary mr-1"
                            onClick={submitForm}
                          >
                            {isEdit ? "Update" : "Create"}
                          </button>{" "}
                          &nbsp;&nbsp;
                          <button type="button"
                            onClick={() => setModal("")}
                            className="btn btn-round btn-default">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
          {activeTab === 'tab4' && (
            <div>
              <ul className="nav nav-tabs mt-2" id="myTabs" role="tablist">
                <li className="nav-item">
                  <a
                    className={`nav-table-tab nav-link ${tableFilter === "searchCve" ? 'active' : ''}`}
                    onClick={() => {
                      setTableFilter('searchCve')
                      setPage(1)
                      setSeachCveTech('')
                      dispatch({
                        type: GET_FOREST_LIST,
                        payload: [],
                      });
                    }}
                  >
                    CVE Search
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link nav-table-tab ${tableFilter === "tech" ? 'active' : ''}`}
                    onClick={() => {
                      setTableFilter('tech')
                      setPage(1)
                      setSeachCveTech('')
                      dispatch({
                        type: GET_FOREST_LIST,
                        payload: [],
                      });
                    }}
                  >
                    Technology
                  </a>
                </li>
              </ul>
              <div className="col-lg-12 col-md-12 p-0">
                <div className="card card_tableBox">
                  <div className="body">
                    {/* Add explanatory text based on the selected tab */}
                    {tableFilter === 'searchCve' && (
                      <div className="alert alert-info mb-3" role="alert">
                        <div className="d-flex align-items-start">
                          <i className="fa fa-info-circle mr-2 mt-1" style={{ fontSize: '18px' }}></i>
                          <div>
                            <strong>Search for Common Vulnerabilities and Exposures (CVEs)</strong>
                            <p className="mb-0 mt-1">
                              Enter a CVE ID (e.g., CVE-2021-44228, CVE-2022-22965) to find all vendors and companies 
                              that are affected by this specific vulnerability. This helps you identify which of your 
                              vendors may be at risk from known security vulnerabilities.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {tableFilter === 'tech' && (
                      <div className="alert alert-info mb-3" role="alert">
                        <div className="d-flex align-items-start">
                          <i className="fa fa-info-circle mr-2 mt-1" style={{ fontSize: '18px' }}></i>
                          <div>
                            <strong>Search for Technology Stack Information</strong>
                            <p className="mb-0 mt-1">
                              Enter a technology name (e.g., Apache, Nginx, WordPress, React) to find all vendors 
                              and companies using this technology. This helps you understand your vendors' technology 
                              stack and identify potential security risks associated with specific technologies.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row justify-content-between mb-2">
                      <div className="col-md-5">
                        <div className="input-group searchBoxInput p-0">
                          <div className="input-group-prepend">
                            <span className="input-group-text bg-white border-right-0">
                              <i className={`fa ${tableFilter === 'searchCve' ? 'fa-shield-alt' : 'fa-cogs'}`}></i>
                            </span>
                          </div>
                          <input
                            type="text"
                            className="form-control border-left-0"
                            value={seachCveTech}
                            placeholder={tableFilter === 'searchCve' ? 'Enter CVE ID (e.g., CVE-2021-44228)' : 'Enter technology name (e.g., Apache, WordPress)'}
                            onChange={(e) => {
                              SearchCve(e)
                            }}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                searchClick();
                              }
                            }}
                          />
                        </div>
                        <small className="text-muted">
                          {tableFilter === 'searchCve' 
                            ? 'Search for specific vulnerabilities across all vendors' 
                            : 'Search for technologies used by your vendors'
                          }
                        </small>
                      </div>
                      <div className="col-lg-2 col-md-6 d-flex align-items-end">
                        <button
                          onClick={searchClick}
                          type="button"
                          style={{ fontWeight: "bold" }}
                          className="btn btn-sm btn-success w-100"
                          disabled={!seachCveTech.trim()}
                        >
                          <i className="fa fa-search mr-1"></i>
                          Search
                        </button>
                      </div>
                    </div>
                    
                    {/* Show search results info */}
                    {currentTableDataForest && currentTableDataForest.length > 0 && (
                      <div className="alert alert-success mb-3" role="alert">
                        <i className="fa fa-check-circle mr-2"></i>
                        Found <strong>{currentTableDataForest.length}</strong> {currentTableDataForest.length === 1 ? 'vendor' : 'vendors'} 
                        {tableFilter === 'searchCve' ? ' affected by this vulnerability' : ' using this technology'}
                      </div>
                    )}

                    {currentTableDataForest && currentTableDataForest.length === 0 && seachCveTech && (
                      <div className="alert alert-warning mb-3" role="alert">
                        <i className="fa fa-exclamation-triangle mr-2"></i>
                        No {tableFilter === 'searchCve' ? 'vulnerabilities' : 'technologies'} found for "{seachCveTech}". 
                        Try a different search term or check the spelling.
                      </div>
                    )}

                    <div className="table-responsive">
                      <table className="table table-custom spacing5 mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: "100px" }}>#</th>
                            <th>Vendor Name
                              <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortField('orgAlpha'); setSortOrder('asc') }}
                              />
                              <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                onClick={() => { setSortField('orgAlpha'); setSortOrder('desc') }}
                              />
                            </th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentTableDataForest?.map((item, index) => {
                            const pageCount = (page - 1) * 10 + 1;
                            return (
                              <tr key={index}>
                                <td style={{ width: "100px" }}>
                                  <span>{pageCount + index}</span>
                                </td>
                                <td>
                                  <div>
                                    <strong>{item.orgName}</strong>
                                    {item.orgContactName && (
                                      <div className="text-muted small">{item.orgContactName}</div>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex gap-2 align-items-center">
                                    {tableFilter === 'searchCve' && (
                                      <Link
                                        to="#"
                                        className="btn btn-sm"
                                        onClick={() => showCveDetails(item?.modules || [])}
                                      >
                                        <i className="fa fa-shield-alt mr-1"></i>
                                        View CVEs
                                      </Link>
                                    )}
                                    {tableFilter !== 'searchCve' && (
                                      <Link
                                        to="#"
                                        className="btn btn-sm btn-outline-info"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedTechstacks(item.techstacks || []);
                                          setShowTechstackModal(true);
                                        }}
                                      >
                                        <i className="fa fa-eye mr-1"></i>
                                        View Details
                                      </Link>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="dataTables_paginate">
                      {totalItemsSearch > 0 && (
                        <Pagination
                          className="pagination-bar"
                          currentPage={page}
                          totalCount={totalItemsSearch}
                          pageSize={PageSize}
                          onPageChange={(page) => setPage(page)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Technology Details Modal */}
              <div className={`modal fade ${techModalOpen ? "d-block show" : ""}`}>
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Technology Details - {selectedCompanyName}</h5>
                      <button
                        type="button"
                        className="close"
                        onClick={() => setTechModalOpen(false)}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="table-responsive">
                        <table className="table table-custom spacing5 mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Subdomain</th>
                              <th>Version</th>
                              <th>Vulnerable</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedTechData.map((tech, index) => (
                              <tr key={tech._id}>
                                <td>{index + 1}</td>
                                <td>{tech.name || "N/A"}</td>
                                <td>{tech.subDomainName || "N/A"}</td>
                                <td>{tech.version || "Not Available"}</td>
                                <td>{tech.hasVulnerabilities ? "Yes" : "No"}</td>
                              </tr>
                            ))}
                            {selectedTechData.length === 0 && (
                              <tr>
                                <td colSpan="5" className="text-center">No technology data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CVE Details Modal */}
              <div className={`modal fade ${cveModalOpen ? "d-block show" : ""}`}>
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">CVE Details</h5>
                      <button
                        type="button"
                        className="close"
                        onClick={() => setCveModalOpen(false)}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {cveData && cveData.length > 0 && (
                        <div>
                          {cveData.map((module, moduleIdx) => (
                            <div key={`module-${moduleIdx}`} className="mb-4">
                              {module.module === "passiveVulnerability" && (
                                <>
                                  <h6 className="mb-3">Passive Vulnerabilities by IP</h6>
                                  {module.details.map((item, idx) => (
                                    <div className="card mb-3" key={`ip-${idx}`} style={{ border: 'none' }}>
                                      <div className="card-header py-3" style={{ border: 'none' }}>
                                        <h6 className="mb-0">
                                          IP: {item.ip} - {item.cves.length} CVEs
                                        </h6>
                                      </div>
                                      <div className="card-body">
                                        <div className="cve-list d-flex flex-wrap">
                                          {item.cves.map((cve, cveIdx) => (
                                            <span
                                              className="badge mr-2 mb-2"
                                              key={`cve-${cveIdx}`}
                                              style={{
                                                backgroundColor: '#08283f',
                                                color: 'white',
                                                padding: '8px 12px',
                                                borderRadius: '4px',
                                                fontSize: '13px'
                                              }}
                                            >
                                              {cve}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}

                              {module.module === "outdatedTechnology" && (
                                <>
                                  <h6 className="mb-3">Outdated Technology Vulnerabilities</h6>
                                  {module.details.map((item, idx) => (
                                    <div className="card mb-3" key={`tech-${idx}`} style={{ border: 'none' }}>
                                      <div className="card-header py-3" style={{ border: 'none' }}>
                                        <h6 className="mb-0">
                                          {item.subDomainName} - {item.technology} {item.version}
                                        </h6>
                                      </div>
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <table className="table table-sm">
                                            <thead>
                                              <tr>
                                                <th>CVE ID</th>
                                                <th>Severity</th>
                                                <th>CVSS Score</th>
                                                <th>Exploitability Score</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {item.cvesInfo.map((cveInfo, cveIdx) => (
                                                <tr key={`cve-info-${cveIdx}`}>
                                                  <td>
                                                    <span
                                                      className="badge mr-2"
                                                      style={{
                                                        backgroundColor: '#08283f',
                                                        color: 'white',
                                                        padding: '4px 8px',
                                                        borderRadius: '4px',
                                                        fontSize: '12px'
                                                      }}
                                                    >
                                                      {cveInfo.cveId}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      className={`badge ${cveInfo.severity === 'HIGH' ? 'badge-danger' :
                                                          cveInfo.severity === 'MEDIUM' ? 'badge-warning' :
                                                            cveInfo.severity === 'LOW' ? 'badge-info' : 'badge-secondary'
                                                        }`}
                                                    >
                                                      {cveInfo.severity || 'N/A'}
                                                    </span>
                                                  </td>
                                                  <td>{cveInfo.cvssScore || 'N/A'}</td>
                                                  <td>{cveInfo.exploitabilityScore || 'N/A'}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 'tab5' &&
            <div>
              <div className="row m-0">
                <div className="col-md-4">
                  <select
                    className="custom-select custom-select-sm bg-white form-control form-control-sm"
                    onChange={(e) => {
                      setCriticalityFilter(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="">Vendor Classification</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>
                <div className="col-md-4 mb-2">
                  <Select
                    components={animatedComponents}
                    isMulti
                    options={options}
                    value={optionValue}
                    onChange={handleChange}
                    placeholder="Select Module"
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: '#08283f',
                        primary25: '#2c2c2c',
                        primary50: '#353535',
                        neutral0: '#dadada',
                        neutral10: '#f0f0f0',
                        neutral20: '#d0d0d0',
                        neutral30: '#b3b3b3',
                        neutral40: '#cccccc',
                        neutral50: '#9e9e9e',
                        neutral60: '#b3b3b3',
                        neutral70: '#cccccc',
                        neutral80: '#e6e6e6',
                        neutral90: '#f2f2f2'
                      }
                    })}
                    styles={{
                      control: (base) => ({
                        ...base,
                        background: 'white',
                        borderColor: '#d0d0d0',
                        boxShadow: 'none',
                        '&:hover': {
                          borderColor: '#08283f'
                        }
                      }),
                      menu: (base) => ({
                        ...base,
                        background: 'white',
                        border: '1px solid #d0d0d0',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        zIndex: 100
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                        color: state.isSelected ? 'white' : '#333333',
                        '&:hover': {
                          background: state.isSelected ? '#08283f' : '#f5f5f5'
                        }
                      }),
                      multiValue: (base) => ({
                        ...base,
                        background: '#f0f0f0',
                        border: '1px solid #d0d0d0'
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: '#9e9e9e',
                        '&:hover': {
                          background: '#08283f',
                          color: 'white'
                        }
                      }),
                      input: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#666666'
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: '#333333'
                      })
                    }}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <Select
                    components={animatedComponents}
                    isMulti
                    options={optionsSubModule}
                    value={optionValueSubModule}
                    onChange={handleChangeSubModule}
                    placeholder="Select Threat Vector"
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: '#08283f',
                        primary25: '#2c2c2c',
                        primary50: '#353535',
                        neutral0: '#dadada',
                        neutral10: '#f0f0f0',
                        neutral20: '#d0d0d0',
                        neutral30: '#b3b3b3',
                        neutral40: '#cccccc',
                        neutral50: '#9e9e9e',
                        neutral60: '#b3b3b3',
                        neutral70: '#cccccc',
                        neutral80: '#e6e6e6',
                        neutral90: '#f2f2f2'
                      }
                    })}
                    styles={{
                      control: (base) => ({
                        ...base,
                        background: 'white',
                        borderColor: '#d0d0d0',
                        boxShadow: 'none',
                        '&:hover': {
                          borderColor: '#08283f'
                        }
                      }),
                      menu: (base) => ({
                        ...base,
                        background: 'white',
                        border: '1px solid #d0d0d0',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        zIndex: 100
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                        color: state.isSelected ? 'white' : '#333333',
                        '&:hover': {
                          background: state.isSelected ? '#08283f' : '#f5f5f5'
                        }
                      }),
                      multiValue: (base) => ({
                        ...base,
                        background: '#f0f0f0',
                        border: '1px solid #d0d0d0'
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: '#9e9e9e',
                        '&:hover': {
                          background: '#08283f',
                          color: 'white'
                        }
                      }),
                      input: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#666666'
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: '#333333'
                      })
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <Select
                    components={animatedComponents}
                    isMulti
                    isClearable
                    isSearchable
                    isLoading={isLoadingTags}
                    options={tagOptions}
                    onChange={(selected) => {
                      setTagsFilter(selected ? selected.map(tag => tag.value).join(',') : '');
                    }}
                    placeholder="Search tags..."
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: '#08283f',
                        primary25: '#2c2c2c',
                        primary50: '#353535',
                        neutral0: '#dadada',
                        neutral10: '#f0f0f0',
                        neutral20: '#d0d0d0',
                        neutral30: '#b3b3b3',
                        neutral40: '#cccccc',
                        neutral50: '#9e9e9e',
                        neutral60: '#b3b3b3',
                        neutral70: '#cccccc',
                        neutral80: '#e6e6e6',
                        neutral90: '#f2f2f2'
                      }
                    })}
                    styles={{
                      control: (base) => ({
                        ...base,
                        background: 'white',
                        borderColor: '#d0d0d0',
                        boxShadow: 'none',
                        '&:hover': {
                          borderColor: '#08283f'
                        }
                      }),
                      menu: (base) => ({
                        ...base,
                        background: 'white',
                        border: '1px solid #d0d0d0',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        zIndex: 100
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                        color: state.isSelected ? 'white' : '#333333',
                        '&:hover': {
                          background: state.isSelected ? '#08283f' : '#f5f5f5'
                        }
                      }),
                      multiValue: (base) => ({
                        ...base,
                        background: '#f0f0f0',
                        border: '1px solid #d0d0d0'
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: '#9e9e9e',
                        '&:hover': {
                          background: '#08283f',
                          color: 'white'
                        }
                      }),
                      input: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#666666'
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: '#333333'
                      })
                    }}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <Select
                    components={animatedComponents}
                    options={selectOptions}
                    value={searchValue}
                    onChange={(selectedCompany) => {
                      if (selectedCompany) {
                        setOrganisationsId(selectedCompany.value);
                        setSearchValue([{ value: selectedCompany.value, label: selectedCompany.label }]);
                        setSearchCompany(selectedCompany.label);
                      } else {
                        // Handle clearing the selection
                        setSearchValue([]);
                        setSearchCompany('');
                        setOrganisationsId('');
                      }
                    }}
                    placeholder="Select Company"
                    isClearable
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: '#08283f',
                        primary25: '#2c2c2c',
                        primary50: '#353535',
                        neutral0: '#dadada',
                        neutral10: '#f0f0f0',
                        neutral20: '#d0d0d0',
                        neutral30: '#b3b3b3',
                        neutral40: '#cccccc',
                        neutral50: '#9e9e9e',
                        neutral60: '#b3b3b3',
                        neutral70: '#cccccc',
                        neutral80: '#e6e6e6',
                        neutral90: '#f2f2f2'
                      }
                    })}
                    styles={{
                      control: (base) => ({
                        ...base,
                        background: 'white',
                        borderColor: '#d0d0d0',
                        boxShadow: 'none',
                        '&:hover': {
                          borderColor: '#08283f'
                        }
                      }),
                      menu: (base) => ({
                        ...base,
                        background: 'white',
                        border: '1px solid #d0d0d0',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        zIndex: 100
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                        color: state.isSelected ? 'white' : '#333333',
                        '&:hover': {
                          background: state.isSelected ? '#08283f' : '#f5f5f5'
                        }
                      }),
                      multiValue: (base) => ({
                        ...base,
                        background: '#f0f0f0',
                        border: '1px solid #d0d0d0'
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: '#9e9e9e',
                        '&:hover': {
                          background: '#08283f',
                          color: 'white'
                        }
                      }),
                      input: (base) => ({
                        ...base,
                        color: '#333333'
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#666666'
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: '#333333'
                      })
                    }}
                  />
                </div>
              </div>
              <table className="table table-custom spacing5 mb-0">
                <thead>
                  <tr>
                    {/* Adjust these headers according to the actual data structure */}
                    <th>Module</th>
                    <th>Threat Vector</th>
                    <th>Findings</th>
                  </tr>
                </thead>
                <tbody>
                  {forestRiskData?.attackSurface?.map((item, index) => (
                    <tr key={index}>
                      {/* Adjust these cells according to the actual data structure */}
                      <td>Attack Surface</td>
                      <td>{formatString(item.moduleName)}</td>
                      <td
                        className="cursor"
                        onClick={() => {
                          findingClick(item)
                        }}
                        style={{ color: '#08283f' }}
                      >
                        {item.risk}</td>
                    </tr>
                  ))}

                  {forestRiskData?.dataExposure?.map((item, index) => (
                    <tr key={index} >
                      {/* Adjust these cells according to the actual data structure */}
                      <td>Data Exposure</td>
                      <td>{formatString(item.moduleName)}</td>
                      <td
                        className="cursor"
                        onClick={() => {
                          findingClick(item)
                        }}
                        style={{ color: '#08283f' }}
                      >
                        {item.risk}</td>
                    </tr>
                  ))}


                  {forestRiskData?.brandSecurity?.map((item, index) => (
                    <tr key={index} >
                      {/* Adjust these cells according to the actual data structure */}
                      <td>Brand Security</td>
                      <td>{formatString(item.moduleName)}</td>
                      <td
                        className="cursor"
                        onClick={() => {
                          findingClick(item)
                        }}
                        style={{ color: '#08283f' }}
                      >
                        {item.risk}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          }
          {
            activeTab === 'tab6' && <>
              <div className="block-header">
                <div className="row clearfix">
                  <div className="col-md-6 col-sm-12">
                    <nav aria-label="breadcrumb p-0 m-0">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item cursor mb-0welcome-textSmall">
                          <span
                            className="welcome-textSmall"
                            onClick={() => {
                              setActiveTab('tab5')
                              setOptionValue()
                              setOptionValueSubModule()
                              setModuleKey()
                              setSubmodules()
                              setOrganisationsId()

                              setSearchValue()
                            }}
                          >Risks /</span> {riskValue}
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
              <table className="table table-custom spacing5 mb-0">
                <thead>
                  <tr>
                    <th>Company</th>
                    <th>Instances</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {dataTable?.map((item) => (
                    <tr key={item?._id}>
                      <td>{item?.orgName}</td>
                      <td>{item?.numberOfInstances}</td>
                      <td className="cursor"
                        onClick={() => {
                          routeCheck(item)
                        }
                        }
                      >View Details</td>
                    </tr>
                  ))}
                </tbody>
              </table></>
          }
        </div>
      </div>

      {<div
        className={`modal fade  ${refreshModal ? "d-block show" : ""}`}
        id="exampleModal"
        onClick={() => setRefreshModal(false)}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Refresh Client?
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to refresh?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-round btn-default"
                data-dismiss="modal"
                onClick={() => setRefreshModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-round btn-primary"
                onClick={() => {
                  refreshCustomer(selectedOrgId);
                  setRefreshModal(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>}
      <Modal
        show={showTechstackModal}
        onHide={() => setShowTechstackModal(false)}
        size="lg"
        aria-labelledby="techstack-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="techstack-modal">Technology Stack Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table table-custom spacing5 mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Version</th>
                  <th>Domain</th>
                  <th>Status</th>
                  <th>Vulnerabilities</th>
                </tr>
              </thead>
              <tbody>
                {selectedTechstacks.map((tech, index) => (
                  <tr key={tech._id}>
                    <td>{index + 1}</td>
                    <td>{tech.name}</td>
                    <td>{tech.version || 'N/A'}</td>
                    <td>{tech.subDomainName}</td>
                    <td>
                      <span className={`badge ${tech.isRemidiated ? 'bg-success' : 'bg-warning'}`}>
                        {tech.isRemidiated ? 'Remediated' : 'Active'}
                      </span>
                    </td>
                    <td>
                      <span className={`badge ${tech.hasVulnerabilities ? 'bg-danger' : 'bg-success'}`}>
                        {tech.hasVulnerabilities ? 'Vulnerable' : 'Secure'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTechstackModal(false)}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default Clients;
